// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Uuid from "uuid";
import * as Stdlib_List from "@rescript/runtime/lib/es6/Stdlib_List.js";

function reducer(state, action) {
  if (typeof action !== "object") {
    return /* [] */0;
  }
  if (action.TAG === "AddRequested") {
    let match = action._0;
    let details = match.details;
    let message = match.message;
    let kind = match.kind;
    if (match.reset) {
      return {
        hd: {
          id: Uuid.v4(),
          content: {
            message: message,
            details: details,
            kind: kind
          }
        },
        tl: /* [] */0
      };
    } else {
      return Stdlib_List.add(state, {
        id: Uuid.v4(),
        content: {
          message: message,
          details: details,
          kind: kind
        }
      });
    }
  }
  let id = action._0;
  return Stdlib_List.filter(state, n => n.id !== id);
}

let initialState = /* [] */0;

export {
  initialState,
  reducer,
}
/* uuid Not a pure module */
